import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash';

import { AuthService } from '../services/auth.service';
import { ENVIRONMENT } from '../../../../environments/environment';

@Injectable()
export class WepInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let tokenUser = this.authService.retrieveToken();
    if (!_.isNull(tokenUser)) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${tokenUser}`
        }
      });
    } else {
      request = request.clone({
        setHeaders: {
          Authorization: `${ENVIRONMENT.CLIENTSECRET}`,
        }
      });
    }
    return next.handle(request);
  }
}
